import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListItemRendererComponent } from 'gung-list';
import { SchedulerOverview } from '../../models/scheduler';
import { DateUtilService } from 'gung-common';

@Component({
  selector: 'lib-schedulers-list',
  templateUrl: './schedulers-list.component.html',
  styleUrl: './schedulers-list.component.scss',
  standalone: false
})
export class SchedulersListComponent extends ListItemRendererComponent<SchedulerOverview[]> {
  lastException: { jobName: string; lastExceptionDate: Date; lastExceptionTrace: string };

  constructor(
    public dateUtilService: DateUtilService,
    protected modalService: NgbModal
  ) {
    super();
  }

  formatExecutionTime(ms: number): string {
    if (ms == null) return '';
    if (ms < 1000) return `${ms}ms`;
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const parts: string[] = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes % 60 > 0) parts.push(`${minutes % 60}m`);
    if (seconds % 60 > 0 || parts.length === 0) parts.push(`${seconds % 60}s`);
    return parts.join(' ');
  }

  showLastExceptionTrace(scheduler: SchedulerOverview, content) {
    this.lastException = {
      jobName: scheduler.jobName,
      lastExceptionDate: scheduler.endTime,
      lastExceptionTrace: scheduler.exception
    };

    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', windowClass: 'modal-xl-custom' })
      .result.finally(() => {
        this.lastException = undefined;
      });
  }
}
